import React, { useEffect } from 'react';
import { Platform, useColorScheme } from 'react-native';

interface XEmbedProps {
  url: string;
}

function extractTweetId(url: string) {
  const match = url.match(/\/status\/(\d+)/);
  return match ? match[1] : null;
}

export function XEmbed({ url }: XEmbedProps) {
  const tweetId = extractTweetId(url);
  const colorScheme = useColorScheme();

  useEffect(() => {
    // Load Twitter widgets script
    const script = document.createElement('script');
    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (!tweetId) {
    return null;
  }

  if (Platform.OS === 'web') {
    return (
      <div className="flex justify-center w-full">
        <div className="mb-20 w-full max-w-[550px] overflow-hidden">
          <blockquote
            className="twitter-tweet"
            data-conversation="none"
            data-theme={colorScheme === 'dark' ? 'dark' : 'light'}
            data-align="center"
          >
            <a href={url} />
          </blockquote>
        </div>
      </div>
    );
  }

  // For native platforms, we'll implement WebView-based solution later
  return null;
}
